<template
  ><svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    class="w-10 h-10"
    :class="{ reverse: open }"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="{2}"
      d="M19 9l-7 7-7-7"
    />
  </svg>
</template>
<script>
export default {
  props: {
    open: Boolean
  }
};
</script>
<style scoped>
svg {
  transition: all 0.5s;
  transition-delay: 0.25s;
}
.reverse {
  transform: rotateX(-180deg);
}
</style>
